import {Component, computed, Signal} from '@angular/core';
import {SeFeEmptyStateModule} from 'se-fe-empty-state';
import {SeFeIconModule} from 'se-fe-icon';
import {select, Store} from '@ngrx/store';
import {OrderHistoryError} from 'app/core/components/error-page/order-history-error';
import {toSignal} from '@angular/core/rxjs-interop';
import {selectError} from 'app/core/components/error-page/state/error.selectors';

@Component({
  selector: 'app-error-page',
  templateUrl: 'error-page.component.html',
  standalone: true,
  imports: [SeFeEmptyStateModule, SeFeIconModule],
})
export class ErrorPageComponent {
  error: Signal<OrderHistoryError | undefined>;

  title = computed(() => {
    return this.error()?.title || "Whoa, that's not in the playbook";
  });

  message = computed(() => {
    return this.error()?.message || 'Something went wrong while trying to load the page. Please try again.';
  });

  constructor(private store: Store) {
    this.error = toSignal(this.store.pipe(select(selectError)));
  }
}
